export default __webpack_public_path__ + "2ff3af3e5565e3581b503ef5e0452493.svg";